import { Extension } from '@tiptap/core';

export const listTabExtension = Extension.create({
  name: 'listTabExtension',

  addKeyboardShortcuts() {
    return {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      Tab: (): boolean => this.editor.commands.sinkListItem('listItem'),
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'Shift-Tab': (): boolean => this.editor.commands.liftListItem('listItem'),
    };
  },
});
